export default __webpack_public_path__ + "static/media/gallery_1_300.69530b30.webp";